<template>
  <a :href="url" target="_blank" rel="noopener noreferrer" class="source-link">
    <template v-if="addSourceText">(source)</template>
    <slot v-else />
  </a>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    url: string
    addSourceText?: boolean
  }>(),
  { addSourceText: false },
)
</script>
